module.exports = __webpack_public_path__ + "static/img/30010 (4).07892ef.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30010 (4).webp
// module id = zzVj
// module chunks = 14